/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EnvironmentService } from '../../core/services/environment.service';
import { CCAdminProxyService } from '../../core/services/cc-admin-proxy-service';

/**
 * Pre-resolves the online/offline mode before the main route renders.
 * Returns `true` immediately for cloud environments.
 * For on-prem, waits for the first CC-Admin Proxy health check to complete.
 */
export const offlineModeResolver: ResolveFn<boolean> = () => {
    const env = inject(EnvironmentService);
    if (env.environment.IS_CLOUD_ENVIRONMENT) {
        return true;
    }
    return inject(CCAdminProxyService).waitForInitialStatus();
};

